exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-195d3dad] .el-dialog{width:1240px!important}[data-v-195d3dad] .ql-container.ql-snow{border:none}.ql-editor[data-v-195d3dad]{padding:12px 0}", ""]);

// exports
